import { motion } from 'framer-motion';
import styled from 'styled-components';

import GridTiles from 'components/GridTiles/GridTiles';
import Headline from 'components/Headline/Headline';
import { mediaDesktop, mediaTablet } from 'utils/styles/responsive';
import { layout } from 'utils/styles/theme';

const columns = layout.columns.max;

export const Wrapper = styled(motion.div)`
  padding: 275px 16px 64px;

  display: grid;
  grid-template-columns:
    [out-left] 16px
    repeat(${columns}, [content] minmax(0px, 1fr))
    [out-right] 16px;

  ${mediaDesktop(`
    grid-template-columns: [out-left] 124px repeat(${columns}, [content] minmax(0px, 1fr)) [out-right] 124px;
  `)}

  ${mediaTablet(`
    padding: 153px 0 360px;
  `)}
`;

export const HeadlineWrapper = styled.section`
  margin-bottom: 238px;
  grid-column: 1/-1;

  ${mediaTablet(`
    grid-column: content 1/out-right;
    margin-bottom: 240px;
  `)}

  ${mediaDesktop(`
    grid-column: content 1/content 9;
  `)}
`;

export const WorkPageHeadline = styled(Headline)``;

export const WorkPageGridTiles = styled(GridTiles)`
  grid-column: 1/ -1;
`;
